interface SearchIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

const SearchIcon = ({
  width = 20,
  height = 20,
  color = '#292929',
  className = '',
}: SearchIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M8.17781 13.3556C6.73068 13.3556 5.50593 12.8544 4.50356 11.8521C3.50119 10.8497 3 9.62494 3 8.17781C3 6.73068 3.50119 5.50593 4.50356 4.50356C5.50593 3.50119 6.73068 3 8.17781 3C9.62494 3 10.8497 3.50119 11.8521 4.50356C12.8544 5.50593 13.3556 6.73068 13.3556 8.17781C13.3556 8.76197 13.2627 9.31294 13.0768 9.83073C12.8909 10.3485 12.6387 10.8065 12.3201 11.2048L16.7809 15.6657C16.927 15.8118 17 15.9976 17 16.2233C17 16.449 16.927 16.6349 16.7809 16.7809C16.6349 16.927 16.449 17 16.2233 17C15.9976 17 15.8118 16.927 15.6657 16.7809L11.2048 12.3201C10.8065 12.6387 10.3485 12.8909 9.83073 13.0768C9.31294 13.2627 8.76197 13.3556 8.17781 13.3556ZM8.17781 11.7624C9.17354 11.7624 10.0199 11.4139 10.7169 10.7169C11.4139 10.0199 11.7624 9.17354 11.7624 8.17781C11.7624 7.18208 11.4139 6.3357 10.7169 5.63869C10.0199 4.94168 9.17354 4.59317 8.17781 4.59317C7.18208 4.59317 6.3357 4.94168 5.63869 5.63869C4.94168 6.3357 4.59317 7.18208 4.59317 8.17781C4.59317 9.17354 4.94168 10.0199 5.63869 10.7169C6.3357 11.4139 7.18208 11.7624 8.17781 11.7624Z'
      fill={color}
    />
  </svg>
);

export default SearchIcon;
